import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class SearchService {

  constructor(
    private http: HttpClient
  ) { }

  private setHeaders(): HttpHeaders {
    const headerConfig = {
       'Content-Type': 'application/json',
       'Accept': 'application/json'
      };
    return new HttpHeaders(headerConfig);
  }
  
 
  public getInformation (data) {
    // const url = 'http://10.20.30.199:8010/search/getSearch' // 200 
    const url = 'https://seguros-mundojoven.com/search/getWebSearch' // 200
    // const url = 'http://www.mocky.io/v2/5b85d3953000008743729461' // Mock
    
    return this.http.post(url, data,{ headers: this.setHeaders() });
  }

  public getInformationCrossSelling (data) {
    // const url = 'http://10.20.30.199:8010/search/getSearch' // 200 
    const url = 'https://seguros-mundojoven.com/search/getCrossSellingProduct' // 200
    // const url = 'http://www.mocky.io/v2/5b85d3953000008743729461' // Mock
    
    return this.http.post(url, data,{ headers: this.setHeaders() });
  }

  public getRegime () {
    let xmls = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/"> <soapenv:Header/> <soapenv:Body> <tem:GetCatalogRF/> </soapenv:Body> </soapenv:Envelope>'
    var url = 'https://marcopolo.mundojoven.com:8443/MJService.asmx'
    return this.http.post(url, xmls, { headers: new HttpHeaders({
      'Content-Type':  'text/xml',
      'Accept':  '*/*'
      }), responseType: 'text'
    });
  }

  public getAddress (address) {
    var satData = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">'
    satData += '<soapenv:Header/>'
    satData += '<soapenv:Body>'
    satData += '<tem:GetAddresses>'
    satData += '<tem:addressRq>'
    satData += '<tem:cp>' + address.cp + '</tem:cp>'
    satData += '<tem:estado>' + address.estado + '</tem:estado>'
    satData += '<tem:municipio>' + address.municipio + '</tem:municipio>'
    satData += '<tem:localidad>' + address.localidad + '</tem:localidad>'
    satData += '<tem:colonia>' + address.colonia + '</tem:colonia>'
    satData += '</tem:addressRq>'
    satData += '</tem:GetAddresses>'
    satData += '</soapenv:Body>'
    satData += '</soapenv:Envelope>'
    var url = 'https://marcopolo.mundojoven.com:8443/MJService.asmx'
    return this.http.post(url, satData, { headers: new HttpHeaders({
      'Content-Type':  'text/xml',
      'Accept':  '*/*'
      }), responseType: 'text'
    });
  }

  public getCommission(data) {
    const url = 'https://seguros-mundojoven.com/commission/getCommission' // 200
    return this.http.post(url, data,{ headers: this.setHeaders() });
  }

}
